import { VIEW_PROGRAMME_FEEDBACK_DATA } from "../../constants";

export function getProgrammeFeedback(data) {
    return {
        type: VIEW_PROGRAMME_FEEDBACK_DATA,
        data
    };
}